import { render, staticRenderFns } from "./EmptyListPlaceholderSidebar.vue?vue&type=template&id=676efd20"
import script from "./EmptyListPlaceholderSidebar.vue?vue&type=script&lang=ts"
export * from "./EmptyListPlaceholderSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('676efd20')) {
      api.createRecord('676efd20', component.options)
    } else {
      api.reload('676efd20', component.options)
    }
    module.hot.accept("./EmptyListPlaceholderSidebar.vue?vue&type=template&id=676efd20", function () {
      api.rerender('676efd20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/EmptyListPlaceholderSidebar.vue"
export default component.exports